import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { ProfileContext } from "../../context/ProfileProvider";

import "./Sidebar.css";
import {
	CalendarMonth,
	Chat,
	CreditCard,
	DocumentScanner,
	Logout,
	Settings,
} from "@mui/icons-material";

function SideBar() {
	const navigate = useNavigate();
	const location = useLocation();
	const [activeLink, setActiveLink] = useState(location.pathname);
	// const { dispatch } = useContext(ProfileContext);

	useEffect(() => {
		setActiveLink(location.pathname);
	}, [location.pathname]);
	const handleLinkClick = (link) => {
		setActiveLink(link);
	};

	const onLogout = () => {
		localStorage.removeItem("user_info");
		console.log("Logged out");
		navigate("/", { replace: true });
		window.location.reload();
	};

	// const onLogout = () => {
	// 	localStorage.removeItem("isLoggedIn");
	// 	localStorage.removeItem("userId");
	// 	navigate("/login");
	// };

	const userId = localStorage.getItem("userId");
	const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
	// if (!userId || !isLoggedIn) {
	// 	return null; // If userId or isLoggedIn is false, don't render the sidebar
	// }

	return (
		<div className="flex flex-col flex-shrink-0 sidebarMenu h-full fixed items-center py-2 left-0 ml-2">
			<Link to="/" className="mb-5">
				<img src="/images/logo-white.png" width={"80px"} alt="" />
			</Link>

			<ul className="nav nav-pills nav-flush flex flex-col mb-auto items-center gap-2">
				<li className="nav-item mb-1 relative w-20">
					<Link
						to="/landing/rpm_list"
						className={`nav-link py-2 bg-transparent ${
							activeLink.startsWith("/landing/rpm_list")
								? "active"
								: ""
						} flex flex-col items-center`}
						onClick={() => handleLinkClick("/landing/rpm_list")}
					>
						<svg
							width="26"
							height="24"
							className="mb-1"
							viewBox="0 0 26 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M8.87936 22.8C9.21224 22.8 9.55304 22.798 9.90128 22.798H16.4934C16.8411 22.798 17.1819 22.8 17.5148 22.8C20.565 22.8 22.8956 22.644 22.8956 19.4553C22.8956 16.1179 20.3432 13.378 17.0835 13.0802C17.0576 14.2478 13.1984 17.1292 13.1984 17.1292C13.1984 17.1292 9.33824 14.248 9.31208 13.0804C6.05288 13.378 3.5 16.1179 3.5 19.4553C3.5 22.644 5.82968 22.8 8.87936 22.8ZM16.0777 18.4456C16.0777 18.3506 16.1634 18.274 16.2699 18.274H17.3125V17.232C17.3125 17.1264 17.3886 17.0397 17.4836 17.0397H18.5125C18.607 17.0397 18.6836 17.1256 18.6836 17.232V18.2743H19.7257C19.8313 18.2743 19.9177 18.3508 19.9177 18.4459V19.4743C19.9177 19.5693 19.832 19.6459 19.7257 19.6459H18.6834V20.688C18.6834 20.794 18.6066 20.88 18.5118 20.88H17.4834C17.3883 20.88 17.3118 20.7943 17.3118 20.688V19.6456H16.2697C16.1636 19.6456 16.0774 19.5691 16.0774 19.474L16.0777 18.4456Z"
								fill="white"
								fillOpacity="0.5"
							/>
							<path
								d="M13.1997 13.918C16.1478 13.918 18.5375 9.48499 18.5375 6.53707C18.5375 3.58963 16.1478 1.19995 13.1997 1.19995C10.252 1.19995 7.8623 3.58963 7.8623 6.53707C7.8623 9.48499 10.252 13.918 13.1997 13.918Z"
								fill="white"
								fillOpacity="0.5"
							/>
						</svg>
						{activeLink.startsWith("/landing/rpm_list") ? (
							<span>Patients</span>
						) : (
							<></>
						)}
					</Link>
				</li>
				<li className="nav-item mb-1 relative w-20">
					<Link
						// to="/document"
						className={`nav-link py-2 bg-transparent ${
							activeLink === "/document" ? "active" : ""
						} flex flex-col items-center`}
						onClick={() => handleLinkClick("/document")}
					>
						{/* <img src="/images/document-icon.svg" alt="" /> */}
						<div
							className={`${
								activeLink === "/document"
									? "text-white"
									: "text-white/50"
							} hover:text-white transition-colors duration-300 ease-in-out`}
						>
							<DocumentScanner />
						</div>
						{activeLink === "/document" ? <span>Docs</span> : <></>}
					</Link>
				</li>
				<li className="nav-item mb-1 relative w-20">
					<Link
						className={`nav-link py-2 bg-transparent flex flex-col items-center ${
							activeLink === "/chat" ? "active" : ""
						}`}
						onClick={() => handleLinkClick("/chat")}
					>
						{/* <img src="/images/message-icon.svg" alt="" /> */}
						<div
							className={`${
								activeLink === "/chat"
									? "text-white"
									: "text-white/50"
							} hover:text-white transition-colors duration-300 ease-in-out`}
						>
							<Chat />
						</div>
						{activeLink === "/chat" ? <span>Chat</span> : <></>}
					</Link>
				</li>
				<li className="nav-item mb-1 relative w-20">
					<Link
						className={`nav-link py-2 bg-transparent flex flex-col items-center ${
							activeLink === "/cards" ? "active" : ""
						}`}
						onClick={() => handleLinkClick("/cards")}
					>
						<div
							className={`${
								activeLink === "/cards"
									? "text-white"
									: "text-white/50"
							} hover:text-white transition-colors duration-300 ease-in-out`}
						>
							<CreditCard />
						</div>
						{activeLink === "/cards" ? <span>Cards</span> : <></>}
					</Link>
				</li>
				<li className="nav-item mb-1 relative w-20">
					<Link
						className={`nav-link py-2 bg-transparent flex flex-col items-center ${
							activeLink === "/calendar" ? "active" : ""
						}`}
						onClick={() => handleLinkClick("/calendar")}
					>
						{/* <img src="/images/calender-icon.svg" alt="" /> */}
						<div
							className={`${
								activeLink === "/calendar"
									? "text-white"
									: "text-white/50"
							} hover:text-white transition-colors duration-300 ease-in-out`}
						>
							<CalendarMonth />
						</div>
						{activeLink === "/calendar" ? (
							<span>Calendar</span>
						) : (
							<></>
						)}
					</Link>
				</li>
				<li className="nav-item mb-1 relative w-20">
					<Link
						// to="/settings"
						className={`nav-link py-2 bg-transparent ${
							activeLink === "/settings" ? "active" : ""
						} flex flex-col items-center`}
						onClick={() => handleLinkClick("/settings")}
					>
						{/* <img src="/images/setting-icon.svg" alt="" /> */}
						<div
							className={`${
								activeLink === "/settings"
									? "text-white"
									: "text-white/50"
							} hover:text-white transition-colors duration-300 ease-in-out`}
						>
							<Settings />
						</div>
						{activeLink === "/settings" ? (
							<span>Settings</span>
						) : (
							<></>
						)}
					</Link>
				</li>

				<li className="nav-item mb-1 relative w-20">
					<Link
						className={`nav-link py-2 bg-transparent flex flex-col items-center`}
						onClick={onLogout}
					>
						<div
							className={`text-white/50 hover:text-white transition-colors duration-300 ease-in-out`}
						>
							<Logout />
						</div>
					</Link>
				</li>
			</ul>
		</div>
	);
}

export default SideBar;
